export const CONSTANTS = {
  MIN_DATE_OF_BIRTH: '1880-05-03T14:37:20.624Z',
  AGE_OF_MAJORITY: 18,
  SKRILL: {
    brandTag: 'skrill',
    brandName: 'skrill',
    brandText: 'Skrill',
    contactUsBrand: 'Skrill',
    logoPathValueCookies: 'assets/skrill/svg/header-logo.svg',
    isCombinedApplication: false,
    cookieScript: '37e3b7bd-f9a6-46b4-89f4-573de931dffc',
    pageTitle: 'Skrill | Sign up for a business account ',
    pageFavicon: 'assets/skrill/svg/logo-letter.svg',
    url: 'https://skrill.com'
  },
  NETELLER: {
    brandTag: 'neteller',
    brandName: 'neteller',
    brandText: 'NETELLER',
    contactUsBrand: 'NETELLER',
    logoPathValueCookies: 'assets/neteller/svg/header-logo.svg',
    isCombinedApplication: false,
    cookieScript: '020a15cb-fd47-499d-91a7-32f79d08533d',
    pageTitle: 'NETELLER | Sign up for a business account',
    pageFavicon: 'assets/neteller/svg/logo-letter.svg',
    url: 'https://neteller.com'
  },
  SKRILL_AND_NETELLER: {
    brandTag: 'skrill_and_neteller',
    brandName: 'skrill-and-neteller',
    brandText: 'Skrill and NETELLER',
    contactUsBrand: 'Skrill & Neteller',
    logoPathValueCookies: 'assets/skrill-and-neteller/svg/header-logo.svg',
    isCombinedApplication: true,
    cookieScript: '5ce97d3d-df33-4298-9f25-f263c2fc0a5a',
    pageTitle: 'Paysafe | Sign up for a business account',
    pageFavicon: 'assets/skrill-and-neteller/svg/logo-letter2.svg'
  },
  PAYSAFECARD: {
    brandTag: 'paysafecard',
    brandName: 'paysafecard',
    brandText: 'Paysafecard',
    contactUsBrand: 'Skrill',
    logoPathValueCookies: 'assets/paysafecard/svg/header-logo.svg',
    isCombinedApplication: false,
    cookieScript: '37e3b7bd-f9a6-46b4-89f4-573de931dffc',
    pageTitle: 'Skrill | Sign up for a business account ',
    pageFavicon: 'assets/paysafecard/svg/logo-letter.svg',
    url: 'https://skrill.com'
  },
  US_TERRITORIES_COUNTRY_IDS: ['AME', 'GUM', 'MNP', 'PUE', 'US_', 'USA'],
  FILE_TYPES: {
    JPG: 'image/jpg',
    JPEG: 'image/jpeg',
    PNG: 'image/png',
    PDF: 'application/pdf',
    ZIP: 'application/zip'
  },
  COMPANY_MEMBER: {
    BUSINESS_CONTACT: 'BUSINESS_CONTACT',
    DIRECTOR: 'DIRECTOR',
    DIRECTOR_AND_UBO: 'DIRECTOR_AND_UBO',
    UBO: 'UBO',
    POSITION: {
      OWN: 'OWN',
      OTH: 'OTH',
      MDR: 'MDR'
    }
  }
};
